// ============================================================
// Hirafi — Module devis : bannière CTA pour les invités
// ============================================================

import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocalizedNavigate } from "@/hooks/useLocalizedNavigate";

interface Props {
  /** Action tentée (ex: "envoyer le devis") */
  action?: string;
}

export function GuestSavePrompt({ action }: Props) {
  const navigate = useLocalizedNavigate();

  return (
    <div className="rounded-xl border border-primary/20 bg-primary/5 p-4 flex items-start gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <Lock className="h-4 w-4 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground">
          {action
            ? `Créez un compte gratuit pour ${action}`
            : "Créez un compte gratuit pour sauvegarder et envoyer votre devis"}
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Votre devis sera automatiquement sauvegardé après inscription.
        </p>
        <div className="flex gap-2 mt-3">
          <Button
            size="sm"
            variant="hero"
            className="gap-1.5"
            onClick={() => navigate("/inscription?redirect=/devis&source=devis_guest")}
          >
            Créer un compte
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => navigate("/connexion?redirect=/devis&source=devis_guest")}
          >
            Se connecter
          </Button>
        </div>
      </div>
    </div>
  );
}
